module.exports = __webpack_public_path__ + "893fbf2ce92da0836d875cefe7ab4c37.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/JO.svg
// module id = eg+L
// module chunks = 0